// extracted by mini-css-extract-plugin
export var Section = "Videos-module--Section--0P1Ka";
export var LangHY = "Videos-module--LangHY--lCnyi";
export var Title = "Videos-module--Title--GA3f0";
export var Text = "Videos-module--Text--dtRyl";
export var SectionTitle = "Videos-module--SectionTitle--fiXtE";
export var Grid = "Videos-module--Grid---s50n";
export var Card = "Videos-module--Card--8hMhN";
export var Frame = "Videos-module--Frame--KC6yw";
export var Poster = "Videos-module--Poster--JW7BZ";
export var Media = "Videos-module--Media--epkel";
export var Play = "Videos-module--Play--QvNev";
export var TitleLink = "Videos-module--TitleLink--+EfK4";
export var arrowLeft = "Videos-module--arrowLeft--XDCjr";
export var arrowRight = "Videos-module--arrowRight--4r+x0";